(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6133],{

/***/ 12453:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getGAUserID = function getGAUserID() {
  try {
    var trackers = ga.getAll();
    var i, len;

    for (i = 0, len = trackers.length; i < len; i += 1) {
      if (trackers[i].get("trackingId") === "UA-186465270-2") {
        return trackers[i].get("clientId");
      }
    }
  } catch (e) {}

  return false;
};

/* harmony default export */ __webpack_exports__["Z"] = (getGAUserID);

/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trigger; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function trigger(eventType, data, fullName) {
  var event = new CustomEvent(eventType, {
    detail: {
      dataForm: _objectSpread({
        fullname: fullName,
        email: data.email
      }, data),
      response: data
    }
  });

  try {
    document.dispatchEvent(event);
  } catch (error) {
    console.log(error);
  }
}

/***/ }),

/***/ 7778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ BiLoaderAlt; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BiLoaderAlt(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 96065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ FiSearch; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiSearch(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "16.65",
        "y2": "16.65"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 66865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j7": function() { return /* binding */ InputEmail; },
/* harmony export */   "oH": function() { return /* binding */ InputText; },
/* harmony export */   "Z6": function() { return /* binding */ InputPhone; },
/* harmony export */   "Jg": function() { return /* binding */ CheckBox; }
/* harmony export */ });
/* unused harmony export InputNumber */
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91164);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["name", "placeholder", "register", "errors", "requiredText"],
    _excluded2 = ["as", "name", "placeholder", "register", "errors", "requiredText"],
    _excluded3 = ["name", "placeholder", "register", "errors", "requiredText", "invalidText"],
    _excluded4 = ["name", "text", "register", "errors", "checkboxTextClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var InputEmail = function InputEmail(_ref) {
  var _errors$name, _errors$email;

  var name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      errors = _ref.errors,
      requiredText = _ref.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "email"
    }, register(name ? name : "email", {
      required: {
        value: true,
        message: requiredText || "Email is required"
      },
      pattern: {
        // Value: /(^(?:[0-9]+[a-z]|[a-z]+[0-9]|[a-z])[a-z0-9._%+-]*)+@[a-z0-9.-]+\.[a-z]{2,}$/,
        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: "Invalid e-mail"
      }
    })), {}, {
      placeholder: placeholder || "Email*",
      pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      className: "w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0 ",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-left text-sm text-red-500",
      children: name ? (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
    })]
  });
}; // Text Field must be single word or multiple word space with "_"

var InputText = function InputText(_ref2) {
  var _errors$name2;

  var as = _ref2.as,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      register = _ref2.register,
      errors = _ref2.errors,
      requiredText = _ref2.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref2, _excluded2);

  var CustomTag = as || "input";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomTag, _objectSpread(_objectSpread({
      type: "text"
    }, register(name, {
      required: {
        value: true,
        message: requiredText || "This field is required"
      }
    })), {}, {
      placeholder: placeholder,
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.message
    })]
  });
};
var InputPhone = function InputPhone(_ref3) {
  var _errors$name3, _errors$phone_number;

  var name = _ref3.name,
      placeholder = _ref3.placeholder,
      register = _ref3.register,
      errors = _ref3.errors,
      requiredText = _ref3.requiredText,
      invalidText = _ref3.invalidText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "text"
    }, register(name || "phone_number", {
      required: {
        value: true,
        message: requiredText || "Phone number is required"
      },
      pattern: {
        value: /[0-9]+/,
        message: invalidText || "Invalid phone number"
      }
    })), {}, {
      placeholder: placeholder,
      pattern: "[0-9]+",
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: name ? (_errors$name3 = errors[name]) === null || _errors$name3 === void 0 ? void 0 : _errors$name3.message : (_errors$phone_number = errors.phone_number) === null || _errors$phone_number === void 0 ? void 0 : _errors$phone_number.message
    })]
  });
};
var InputNumber = function InputNumber(_ref4) {
  var numberValue = _ref4.numberValue,
      min = _ref4.min,
      max = _ref4.max,
      setNumberValue = _ref4.setNumberValue;

  var handleOnclickNumber = function handleOnclickNumber(number) {
    setNumberValue(number);
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative flex w-28 items-center lg:mb-6 lg:w-40",
      children: [/*#__PURE__*/_jsx("button", {
        className: "absolute left-2 w-5 lg:left-5 ",
        onClick: function onClick(event) {
          if (numberValue > min) {
            handleOnclickNumber(parseInt(numberValue, 10) - 1);
          }

          event.preventDefault();
        },
        children: "-"
      }), /*#__PURE__*/_jsx("button", {
        className: "absolute right-2 w-5 lg:right-5 ",
        onClick: function onClick(event) {
          if (numberValue < max) {
            handleOnclickNumber(parseInt(numberValue, 10) + 1);
          }

          event.preventDefault();
        },
        children: "+"
      }), /*#__PURE__*/_jsx("input", {
        className: "moz:appearance-none h-10 w-28 rounded-full border-zinc-200 text-center lg:w-40",
        type: "text",
        value: numberValue,
        onKeyPress: function onKeyPress(event) {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        },
        min: min,
        onChange: function onChange(event) {
          event.preventDefault();
          var newValue = event.target.value;

          if (newValue === "") {
            setNumberValue("");
          } else if (newValue < min) {
            setNumberValue(min);
          } else if (newValue > max) {
            setNumberValue(max);
          } else {
            setNumberValue(newValue);
          }
        },
        onBlur: function onBlur() {
          if (numberValue < min) {
            setNumberValue(min);
          }
        }
      })]
    })
  });
};
var CheckBox = function CheckBox(_ref5) {
  var _errors$name4;

  var name = _ref5.name,
      text = _ref5.text,
      register = _ref5.register,
      errors = _ref5.errors,
      checkboxTextClassName = _ref5.checkboxTextClassName,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref5, _excluded4);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "relative block pl-7",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
        type: "checkbox"
      }, register(name, {})), {}, {
        className: "bbc-checkbox absolute left-1 top-1 cursor-pointer rounded border-bbc-silver bg-transparent focus:shadow-none focus:outline-none focus:ring-0"
      }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: checkboxTextClassName ? checkboxTextClassName : "",
        dangerouslySetInnerHTML: {
          __html: text
        }
      })]
    }), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name4 = errors[name]) === null || _errors$name4 === void 0 ? void 0 : _errors$name4.message
    })]
  });
};

/***/ }),

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 85882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56727);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11856);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14388);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var contentStatus = {
  success: {
    title: "Send Success",
    description: "We'll contact you all right away."
  },
  error: {
    title: "Send Error",
    description: "Please check your network connection and try again"
  }
};
var timer = null;

var RenderContent = function RenderContent(_ref) {
  var sendStatus = _ref.sendStatus,
      sendContent = _ref.sendContent,
      setIsOpen = _ref.setIsOpen;

  switch (sendStatus) {
    case "success":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/icons/checked.png",
              width: 90,
              height: 92,
              alt: "icon success",
              className: "mb-6"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-800",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-gray",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "error":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/error.png",
            width: 90,
            height: 92,
            alt: "icon error",
            className: "mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "confirm":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/warning.png",
            width: 98,
            height: 100,
            alt: "icon error",
            className: "mx-auto mb-6",
            wrapper: {
              className: "block"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "flex justify-around",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              variant: "outline",
              btnTextColor: "text-bbc-red-300 hover:text-white",
              btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
              btnColor: "bg-transparent hover:bg-bbc-red-400",
              othersClass: "w-28",
              onClick: function onClick() {
                setIsOpen(false);
              },
              children: "No"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              othersClass: "w-28",
              onClick: function onClick() {
                sendContent.onClick();
                setIsOpen(false);
              },
              children: "Yes"
            })]
          })]
        });
      }

    case "custom":
      {
        return sendContent.element;
      }

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "mb-6 text-2xl font-semibold text-bbc-red-600",
          children: contentStatus.error.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-sm",
          children: contentStatus.error.description
        })]
      });
  }
};

function Toast(_ref2) {
  var children = _ref2.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendStatus = _useState2[0],
      setSendStatus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendContent = _useState3[0],
      setSendContent = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      bgAlert = _useState4[0],
      setBgAlert = _useState4[1];
  /* Handle Event */


  var closeModal = function closeModal(otherAction) {
    setIsOpen(false);

    if (otherAction) {
      try {
        otherAction(); // eslint-disable-next-line no-empty
      } catch (error) {}
    }

    clearTimeout(timer);
    document.documentElement.removeAttribute("style");
  };

  var openAlert = /*#__PURE__*/function () {
    var _ref3 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(time, status, content, otherAction) {
      var closeModalAfterTime;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              closeModalAfterTime = function _closeModalAfterTime(timeToClose) {
                return new Promise(function (resolve) {
                  timer = setTimeout(function () {
                    closeModal(otherAction);
                    resolve("closed");
                  }, timeToClose);
                });
              };

              if (content) {
                setSendContent(content);
              } else {
                setSendContent(contentStatus[status]);
              }

              _context.t0 = status;
              _context.next = _context.t0 === "success" ? 5 : _context.t0 === "error" ? 7 : _context.t0 === "confirm" ? 9 : _context.t0 === "custom" ? 11 : 13;
              break;

            case 5:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 7:
              setBgAlert("from-[#dd3333] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 9:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 11:
              setBgAlert(sendContent.bgAlert || "from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 13:
              return _context.abrupt("break", 14);

            case 14:
              setSendStatus(status);
              setIsOpen(true);

              if (!time) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return closeModalAfterTime(time);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openAlert(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /* Effect */


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(common_contexts__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext.Provider */ .uL.Provider, {
    value: {
      openAlert: openAlert,
      setOpenAlert: setIsOpen
    },
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .uT, {
      show: isOpen,
      as: "div",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog */ .Vq, {
        open: isOpen,
        as: "div",
        className: "fixed inset-0  overflow-y-auto",
        onClose: closeModal,
        style: {
          zIndex: 100
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "fixed inset-0 bg-black/30",
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog.Overlay */ .Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ToastContent), " relative inline-flex w-full flex-col  justify-center border-2 bg-gradient-to-b px-7  py-28 text-center align-middle transition-all ").concat(bgAlert, " rounded-2xl shadow-xl"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "absolute top-6 right-4",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none ",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__/* .FaTimes */ .a, {
                    size: 12
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "relative ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(RenderContent, {
                  sendContent: sendContent,
                  sendStatus: sendStatus,
                  setIsOpen: setIsOpen
                })
              })]
            })
          })]
        })]
      })
    })]
  });
}

/***/ }),

/***/ 56133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(40037);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 2 modules
var react_select_esm = __webpack_require__(99973);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-a86253bb.esm.js + 3 modules
var index_a86253bb_esm = __webpack_require__(57003);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/fetch/getGAUserID.js
var getGAUserID = __webpack_require__(12453);
// EXTERNAL MODULE: ./common/trigger.js
var trigger = __webpack_require__(62951);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/bi/BiLoaderAlt.js
var BiLoaderAlt = __webpack_require__(7778);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiChevronDown.js
var FiChevronDown = __webpack_require__(49604);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiSearch.js
var FiSearch = __webpack_require__(96065);
// EXTERNAL MODULE: ./components/atoms/Input/index.js
var Input = __webpack_require__(66865);
// EXTERNAL MODULE: ./components/atoms/Recaptcha/index.js
var Recaptcha = __webpack_require__(78762);
// EXTERNAL MODULE: ./components/templates/offshore/contact-us/FormContact/Index.module.scss
var Index_module = __webpack_require__(8843);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/contact-us/FormContact/index.js




var _excluded = ["children", "isOpen", "target", "onClose"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      target = _ref.target,
      onClose = _ref.onClose,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative bg-bbc-white ".concat(props.className && props.className),
    children: [target, isOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute z-20 w-full rounded-sm bg-bbc-white pt-2 shadow-lg",
      style: {
        height: "70px"
      },
      children: children
    }) : null, isOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "fixed bottom-0 left-0 top-0 right-0 z-10",
      onClick: onClose
    }) : null]
  });
};

var IconSearch = function IconSearch() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FiSearch/* FiSearch */.j, {
    className: " mr-2 text-bbc-neutral-700"
  });
};

var CustomOption = function CustomOption(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_a86253bb_esm.c.Option, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex cursor-pointer items-center",
      children: [props.data.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        style: {
          marginRight: 8,
          width: 25,
          height: 18
        },
        src: "".concat(props.data.icon.toLowerCase(), ".svg"),
        alt: "".concat(props.data.name.toLowerCase())
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-sm",
        children: props.data.name || props.data.label
      })]
    })
  }));
}; // Styled components


var customSelectStylesPhoneCode = {
  control: function control(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      height: 42,
      minHeight: 42,
      fontSize: "14px",
      margin: "0 8px"
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      fontSize: "14px"
    });
  }
}; //* Dropdown Select - END */

var Component = function Component(_ref2) {
  var description = _ref2.description,
      descriptionClass = _ref2.descriptionClass;

  var _useContext = (0,react.useContext)(contexts/* LayoutContext */.VY),
      locationRouter = _useContext.locationRouter;

  var _useContext2 = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext2.openAlert; // Const toast = useToast(3000);


  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      setValue = _useForm.setValue,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      isSubmitted = _useForm$formState.isSubmitted,
      isSubmitSuccessful = _useForm$formState.isSubmitSuccessful,
      errors = _useForm$formState.errors;

  var countryList = [{
    id: 8,
    label: "Anguilla",
    value: "Anguilla",
    flagSrc: "ai"
  }, {
    id: 17,
    label: "Bahamas",
    value: "Bahamas",
    flagSrc: "bs"
  }, {
    id: 23,
    label: "Belize",
    value: "Belize",
    flagSrc: "bz"
  }, {
    id: 32,
    label: "British Virgin Islands",
    value: "British Virgin Islands",
    flagSrc: "vg"
  }, {
    id: 41,
    label: "Cayman Islands",
    value: "Cayman Islands",
    flagSrc: "ky"
  }, {
    id: 58,
    label: "Cyprus",
    value: "Cyprus",
    flagSrc: "cy"
  }, {
    id: 250,
    label: "Delaware",
    value: "Delaware",
    flagSrc: "us"
  }, {
    id: 98,
    label: "Hong Kong",
    value: "Hong Kong",
    flagSrc: "hk"
  }, {
    id: 111,
    label: "Jersey",
    value: "Jersey",
    flagSrc: "je"
  }, {
    id: 136,
    label: "Marshall Islands",
    value: "Marshall Islands",
    flagSrc: "mh"
  }, {
    id: 139,
    label: "Mauritius",
    value: "Mauritius",
    flagSrc: "mu"
  }, {
    id: 169,
    label: "Panama",
    value: "Panama",
    flagSrc: "pa"
  }, {
    id: 183,
    label: "Samoa",
    value: "Samoa",
    flagSrc: "ws"
  }, {
    id: 189,
    label: "Seychelles",
    value: "Seychelles",
    flagSrc: "sc"
  }, {
    id: 191,
    label: "Singapore",
    value: "Singapore",
    flagSrc: "sg"
  }, {
    id: 205,
    label: "St. Kitts & Nevis",
    value: "St. Kitts & Nevis",
    flagSrc: "kn"
  }, {
    id: 209,
    label: "St. Vincent & Grenadines",
    value: "St. Vincent & Grenadines",
    flagSrc: "vc"
  }, {
    id: 236,
    label: "Ras Al Khaimah (UAE)",
    value: "Ras Al Khaimah (UAE)",
    flagSrc: "ae"
  }, {
    id: 237,
    label: "United Kingdom",
    value: "United Kingdom",
    flagSrc: "gb"
  }, {
    id: 244,
    label: "Vietnam",
    value: "Vietnam",
    flagSrc: "vn"
  }];
  var IncorporationOptions = [{
    value: "Incorporation Service",
    label: "Incorporation Service"
  }, {
    value: "Bank account support",
    label: "Bank account support"
  }, {
    value: "Virtual office",
    label: "Virtual office"
  }, {
    value: "Legal ancillary service",
    label: "Legal ancillary service"
  }, {
    value: "Accounting and auditing",
    label: "Accounting and auditing"
  }, {
    value: "Others",
    label: "Others"
  }];

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)(""),
      phoneCountry = _useState2[0],
      setPhoneCountry = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      phoneCodeList = _useState3[0],
      setPhoneCodeList = _useState3[1];

  var _useState4 = (0,react.useState)(),
      country = _useState4[0],
      setCountry = _useState4[1];

  var _useState5 = (0,react.useState)(countryList),
      countries = _useState5[0];

  var _useState6 = (0,react.useState)(IncorporationOptions[0]),
      service = _useState6[0],
      setService = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isOpenDropdown = _useState7[0],
      setIsOpenDropdown = _useState7[1]; // Const filterPhoneCodes =
  //   String(phoneCountry) === ""
  //     ? phoneCodeList.slice()
  //     : phoneCodeList.filter((item) =>
  //         Item.label
  //           .toLowerCase()
  //           .replace(/\s+/g, "")
  //           .includes(String(phoneCountry).toLowerCase().replace(/\s+/g, ""))
  //       );


  var recaptchaRef = (0,react.useRef)(); // Static_data country

  (0,react.useEffect)(function () {
    axios_default().get("".concat("https://core.test-lp.bbcincorp.com", "/api/onboarding/country")).then(function (result) {
      var _result$data, _result$data$data;

      var phoneList = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : (_result$data$data = _result$data.data) === null || _result$data$data === void 0 ? void 0 : _result$data$data.filter(function (item) {
        return item.is_country === 1;
      }).map(function (item) {
        return {
          label: "".concat(item.country_code, " +").concat(item.phone_code),
          value: item.id
        };
      });
      setPhoneCodeList(phoneList);
    });
  }, []); // Data geoLooking

  (0,react.useEffect)(function () {
    axios_default().get("".concat("https://core.test-lp.bbcincorp.com", "/api/helper/geoLooking")).then(function (result) {
      var _result$data2, _result$data2$data;

      setPhoneCountry(result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : (_result$data2$data = _result$data2.data) === null || _result$data2$data === void 0 ? void 0 : _result$data2$data.id);
    });
  }, []); // Get phoneCountry

  var handleChangePhoneCountry = function handleChangePhoneCountry(newValue) {
    setValue("phone_country_id", newValue === null || newValue === void 0 ? void 0 : newValue.value, {
      shouldValidate: true
    });
    setPhoneCountry(newValue === null || newValue === void 0 ? void 0 : newValue.value);
  };

  var onSelectCountryChange = function onSelectCountryChange(newCountry) {
    setValue("country_id", newCountry.id, {
      shouldValidate: true
    });
    setCountry(newCountry);
  };

  var onSelectSubjectChange = function onSelectSubjectChange(subject) {
    setValue("subject", subject === null || subject === void 0 ? void 0 : subject.value, {
      shouldValidate: true
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var dataSend, token, GAUserID, formData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dataSend = _objectSpread({}, data);
              dataSend.subject = service.value;
              dataSend.phone_country_id = phoneCountry;
              _context.next = 5;
              return recaptchaRef.current.executeAsync();

            case 5:
              token = _context.sent;

              if (token) {
                GAUserID = (0,getGAUserID/* default */.Z)();
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1";
                formData = {
                  first_name: dataSend.first_name,
                  last_name: dataSend.last_name,
                  email: dataSend.email,
                  country_id: dataSend.country_id,
                  phone_country_id: dataSend.phone_country_id,
                  phone_number: dataSend.phone_number,
                  subject: dataSend.subject,
                  message: dataSend.message,
                  client_id: dataSend.client_id,
                  website_id: dataSend.website_id
                };
                axios_default().post("".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form"), formData, {
                  headers: {
                    "captcha-response": token
                  }
                }).then(function (response) {
                  (0,trigger/* default */.Z)("contact_form", formData, "Contact form");

                  if (response.data.state) {
                    reset();
                    clearErrors();
                    setCountry(null);
                    setService(IncorporationOptions[0]);
                    openAlert(3000, "success"); // Toast("success", "We'll contact you all right away");
                  } else {
                    openAlert(3000, "error"); // Toast(
                    //   "error",
                    //   "Please check your network connection and try again"
                    // );
                  }

                  setIsLoading(false);
                })["catch"](function () {
                  clearErrors();
                  openAlert(3000, "error"); // Toast("error", "Please check your network connection and try again");
                  // Console.log(error);
                });
              } else {
                setIsLoading(false);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var renderCountryListbox = function renderCountryListbox() {
    var listCountryFiltered = (0,toConsumableArray/* default */.Z)(countries);

    if (locationRouter === "offshore") {
      listCountryFiltered = countries.filter(function (item) {
        return !["Hong Kong", "Singapore", "Vietnam"].includes(item.value);
      });
    }

    return listCountryFiltered.map(function (item, itemIdx) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
        value: item,
        className: "list-none",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex cursor-pointer items-center gap-x-3 p-2 font-medium ".concat((country === null || country === void 0 ? void 0 : country.label) === item.label ? "bg-bbc-primary text-white" : "hover:bg-bbc-primary hover:bg-opacity-40"),
          onClick: function onClick() {
            return setCountry(item);
          },
          children: [(item === null || item === void 0 ? void 0 : item.flagSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/flags/1x1/".concat(item.flagSrc, ".svg"),
            width: 24,
            height: 24,
            className: "min-h-[24px] min-w-[24px] rounded-full",
            alt: item.flagSrc
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "truncate",
            children: item.label
          })]
        })
      }, itemIdx);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((Index_module_default()).wrapper),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "".concat(descriptionClass ? descriptionClass : "mb-6 lg:mb-10"),
      children: description
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: handleSubmit(onSubmit),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputText */.oH, {
          register: register,
          errors: errors,
          name: "first_name",
          placeholder: "First Name*",
          requiredText: "First Name is required"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputText */.oH, {
          register: register,
          errors: errors,
          name: "last_name",
          placeholder: "Last Name*",
          requiredText: "Last Name is required"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputEmail */.j7, {
          register: register,
          errors: errors
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
          as: "div",
          value: country,
          onChange: onSelectCountryChange,
          className: "relative   w-full border-0 border-b border-b-gray-300 pl-2",
          style: {
            height: "42px"
          },
          children: function children(_ref4) {
            var open = _ref4.open;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Button */.Ri.Button, {
                as: "div",
                role: "button",
                className: "relative h-full w-full select-none pr-9 text-left focus:outline-0",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex items-center gap-x-2 pb-4",
                  children: [(country === null || country === void 0 ? void 0 : country.flagSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/flags/1x1/".concat(country.flagSrc, ".svg"),
                    width: 24,
                    height: 24,
                    className: "min-h-[24px] min-w-[24px] rounded-full",
                    alt: country.flagSrc
                  }), country !== null && country !== void 0 && country.label ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "truncate tracking-[0.25px] text-bbc-gray",
                    children: country === null || country === void 0 ? void 0 : country.label
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "truncate tracking-[0.25px] text-gray-300",
                    children: "Country of interest*"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
                    className: "absolute right-4 top-1/3 float-right -translate-y-1/2 transform align-middle text-bbc-gray ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
                    size: 24
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                show: open,
                leave: "transition-all duration-200 ease-out",
                leaveFrom: "transform opacity-50",
                leaveTo: "transform opacity-0",
                className: "absolute z-10 mt-2 w-full",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "overflow-hidden rounded-md shadow-md",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
                    className: "max-h-60 overflow-auto bg-white focus:outline-none",
                    children: renderCountryListbox()
                  })
                })
              })]
            });
          }
        }), !country && isSubmitted && !isSubmitSuccessful && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "block pt-2 text-sm text-red-500",
          children: "Country is required"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-6 flex flex-col items-stretch space-y-6 lg:flex-row lg:space-y-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, {
          isOpen: isOpenDropdown,
          onClose: function onClose() {
            return setIsOpenDropdown(!isOpenDropdown);
          },
          className: "w-full lg:mr-2 lg:w-2/5",
          target: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            role: "button",
            className: "relative block h-10 w-full cursor-pointer border-b border-gray-300 bg-bbc-white px-2 py-2",
            onClick: function onClick() {
              return setIsOpenDropdown(!isOpenDropdown);
            },
            children: [phoneCodeList && phoneCodeList.find(function (item) {
              return item.value === phoneCountry;
            }) ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex items-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-sm text-[#888]",
                children: phoneCodeList.find(function (item) {
                  return item.value === phoneCountry;
                }).label
              })
            }) : "Select...", /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
              className: "absolute bottom-1/4 right-4 ".concat(isOpenDropdown ? "rotate-180" : "rotate-0", " transition-all duration-200"),
              size: 24
            })]
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
            autoFocus: true,
            className: (Index_module_default()).customSelectSearch,
            backspaceRemovesValue: false,
            controlShouldRenderValue: false,
            hideSelectedOptions: false,
            isClearable: false,
            menuIsOpen: true,
            options: phoneCodeList,
            placeholder: "Search...",
            tabSelectsValue: false,
            value: phoneCodeList && phoneCodeList.find(function (item) {
              return item.value === phoneCountry;
            }),
            styles: customSelectStylesPhoneCode,
            components: {
              Option: CustomOption,
              IndicatorSeparator: function IndicatorSeparator() {
                return null;
              },
              DropdownIndicator: IconSearch
            },
            onChange: handleChangePhoneCountry
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden items-start lg:flex",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "bottom-4 h-10 w-[1px] rounded-full bg-slate-300"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputPhone */.Z6, {
            register: register,
            errors: errors,
            name: "phone_number",
            placeholder: "Phone Number*"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
          as: "div",
          value: service,
          onChange: onSelectSubjectChange,
          className: "relative  w-full border-0 border-b border-b-gray-300",
          style: {
            height: "42px"
          },
          children: function children(_ref5) {
            var open = _ref5.open;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Button */.Ri.Button, {
                as: "div",
                role: "button",
                className: "relative h-full w-full select-none pr-9 text-left focus:outline-0",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex items-center gap-x-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "truncate tracking-[0.25px] text-bbc-gray",
                    children: service.label
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
                    className: "absolute right-4 top-1/3 float-right -translate-y-1/2 transform align-middle text-bbc-gray  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
                    size: 24
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                show: open,
                leave: "transition-all duration-200 ease-out",
                leaveFrom: "transform opacity-50",
                leaveTo: "transform opacity-0",
                className: "absolute z-10 mt-2 w-full",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "overflow-hidden rounded-md shadow-md",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
                    className: "max-h-60 overflow-auto bg-white focus:outline-none",
                    children: IncorporationOptions.map(function (item, itemIdx) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                        value: item,
                        className: "list-none",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "flex cursor-pointer items-center gap-x-3 p-2 font-medium ".concat(service.label === item.label ? "bg-bbc-primary text-white" : "hover:bg-bbc-primary hover:bg-opacity-40"),
                          onClick: function onClick() {
                            return setService(item);
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "truncate",
                            children: item.label
                          })
                        })
                      }, itemIdx);
                    })
                  })
                })
              })]
            });
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputText */.oH, {
          as: "textarea",
          register: register,
          errors: errors,
          name: "message",
          placeholder: "Message*",
          requiredText: "Message is required"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row flex-wrap items-end justify-between space-y-2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 mb-6 flex items-end justify-center lg:col-7 lg:mb-0 lg:justify-start",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "inline-block overflow-hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Recaptcha/* default */.Z, {
              ref: recaptchaRef,
              className: "mx-auto w-max"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 text-center lg:col-5",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
            type: "submit",
            id: "form-contact-us-button",
            disabled: isLoading,
            othersClass: "relative inline-flex justify-center items-center w-full px-2",
            onClick: function onClick() {
              if (isSubmitting) setIsLoading(true);
            },
            children: [isSubmitting && /*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
              className: "mr-2 inline-block animate-spin",
              size: 20
            }), "Send Your Message"]
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var FormContact = (Component);
Component.defaultProps = {
  locationRouter: "",
  description: "",
  descriptionClass: ""
};
/** ========== */
;// CONCATENATED MODULE: ./components/templates/offshore/contact-us/index.js









var ContactUs = function ContactUs(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-569",
        title: data === null || data === void 0 ? void 0 : data.title,
        description: "",
        bgColor: "bg-bbc-terms-policy",
        breadcrumbs: data === null || data === void 0 ? void 0 : data.breadcrumbs,
        titleProps: {
          className: "banner-default-title mb-10",
          textColor: "banner-title-gradient-color"
        },
        leftClassName: "lg:col-7",
        rightClassName: "lg:col-5",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: data === null || data === void 0 ? void 0 : data.banner_image,
          width: 595,
          height: 468,
          alt: "banner",
          wrapper: {
            className: "bbc-banner-image-bottom-0"
          },
          className: "w-full",
          priority: true
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mb-10 lg:col-7 lg:mb-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact, {
                region: data === null || data === void 0 ? void 0 : data.country,
                description: "All information entered on this form will be kept strictly confidential and subject to our privacy policy."
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "px-4 lg:col-4 ",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col justify-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                className: "title-h2 mb-6 font-semibold text-bbc-brand-800 lg:mb-10",
                children: "Get In Touch!"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6 border-0 border-b border-b-bbc-neutral-600 pb-6",
                children: "Thank you for visiting us. At BBCIncorp, we always put the client satisfaction on top of our business plan. If you have any enquiries regarding our service, please feel free to contact us. Our expert team will get back to you soonest."
              }), (data === null || data === void 0 ? void 0 : data.contacts) && (data === null || data === void 0 ? void 0 : data.contacts.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mb-6 border-0 border-b border-b-bbc-neutral-600",
                children: data.contacts.map(function (item, itemIdx) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "mb-6 flex items-center",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mr-3",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                        src: item === null || item === void 0 ? void 0 : item.icon,
                        alt: item === null || item === void 0 ? void 0 : item.altText,
                        width: 48,
                        height: 48,
                        className: "h-full w-full",
                        wrapper: {
                          className: "block w-12"
                        }
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "text-black",
                        children: item === null || item === void 0 ? void 0 : item.description
                      })
                    })]
                  }, itemIdx);
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  className: "mb-6 text-2xl font-semibold leading-9 text-bbc-brand-800",
                  children: "Business Working Hours"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mb-4 flex items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mr-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                      src: "/assets/icons/clock-outline.svg",
                      alt: "clock-outline",
                      width: 18,
                      height: 18,
                      className: "h-full w-full",
                      wrapper: {
                        className: "block ",
                        style: {
                          width: "18px"
                        }
                      }
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-black ",
                      children: "Monday \u2013 Friday 9am to 5.30pm"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mb-4 flex items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mr-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                      src: "/assets/icons/calendar-outline.svg",
                      alt: "calendar-outline",
                      width: 18,
                      height: 18,
                      className: "h-full w-full",
                      wrapper: {
                        className: "block ",
                        style: {
                          width: "18px"
                        }
                      }
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-black",
                      children: "Saturday & Sunday-Closed"
                    })
                  })]
                })]
              })]
            })
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var contact_us = (ContactUs);

/***/ }),

/***/ 14388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ToastContent":"Index_ToastContent__WZ1XO"};

/***/ }),

/***/ 8843:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customSelectSearch":"Index_customSelectSearch__MiC2J","wrapper":"Index_wrapper__bUxx2"};

/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

}]);